import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';
import { Upload, FileDown, Download, X, Search, Users, FileQuestion, Target, Heart, Bell, Sun, HelpCircle, Settings, LogOut, Folder, ArrowUp, FileText, Menu } from 'lucide-react';
import * as XLSX from 'xlsx';
import { ClipLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, Modal, Tooltip, Checkbox, FormControlLabel, Snackbar, Alert } from '@mui/material';
import { IconButton } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import Sidebar_v2 from '../sidebar/Sidebar_v2';
import { useRecoilValue, useSetRecoilState, useRecoilState } from 'recoil';
import useLambda from '../hooks/useLambda';
import { importNotificationsState, responseErrorState, numeroActiveState } from '../../store/atoms';
import { fetchAuthSession } from 'aws-amplify/auth';
import { logEvent } from '../../cloudwatchLogger';
import AWS from 'aws-sdk';
import {
  jwtTokenState, 
  rolesState,
  tenantGroupState,
  isSuperAdminState,
  isTenantAdminRoleState
} from '../../store/atoms';
import {
  conversationIdState,
  numeroActiveStatesetError
} from '../../store/atoms';

import { ChevronDown, ChevronUp } from 'lucide-react';
import WelcomeHeader from './WelcomeHeader';
import { awsExports } from '../../aws-exports';
import FilePreviewModal from './FilePreviewModal'; // Import the modal component
import axios from "axios";
import { firstNameState, displayRoleState, selectedTeamState } from "../../store/atoms";

const FolderWithArrow = ({ size, color }) => (
  <div className="relative inline-block">
    <Folder size={size} color={color} />
    <ArrowUp 
      size={size * 0.3} 
      color={color} 
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    />
  </div>
);

const SuccessMessage = ({ message, onClose, isCustomDesign }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        width: '90%',
        maxWidth: '600px',
        padding: '12px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        borderRadius: '13px',
        // color code red for error EF6950
        border: `2px solid ${isCustomDesign ? '#40C5AF' : '#40C5AF'}`,
        // color code red for error FDF0EE
        background: isCustomDesign ? '#ECF9F7' : '#ECF9F7', 
        boxShadow: '2px 2px 8px 0px rgba(0, 0, 0, 0.10)',
        fontSize: window.innerWidth < 768 ? '14px' : '16px',
        margin: '0 auto',
        wordBreak: 'break-word',
      }}
    >
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%', 
        alignItems: 'center',
        padding: window.innerWidth < 768 ? '0 4px' : '0 8px'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px',
          fontSize: window.innerWidth < 768 ? '14px' : '16px'
        }}>
          {isCustomDesign ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M10.3633 3.95728L2.25653 18.017C2.08938 18.3177 2.00094 18.6587 2.00001 19.0059C1.99907 19.3531 2.08567 19.6946 2.25119 19.9963C2.41671 20.2979 2.65538 20.5493 2.94346 20.7254C3.23153 20.9015 3.55897 20.9962 3.8932 21H20.1068C20.441 20.9962 20.7685 20.9015 21.0565 20.7254C21.3446 20.5493 21.5833 20.2979 21.7488 19.9963C21.9143 19.6946 22.0009 19.3531 22 19.0059C21.9991 18.6587 21.9106 18.3177 21.7435 18.017L13.6367 3.95728C13.466 3.66505 13.2258 3.42345 12.9391 3.25577C12.6524 3.08809 12.329 3 12 3C11.671 3 11.3476 3.08809 11.0609 3.25577C10.7742 3.42345 10.534 3.66505 10.3633 3.95728Z" stroke="#40C5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 9V13" stroke="#40C5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 16.5V17" stroke="#40C5AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ) : (
            <img 
              src="/importsuccess.png" 
              alt="Success" 
              style={{ 
                width: window.innerWidth < 768 ? '20px' : '24px', 
                height: window.innerWidth < 768 ? '20px' : '24px' 
              }} 
            />
          )}
          <span style={{ fontWeight: 'bold', color: isCustomDesign ? '#40C5AF' : '#40C5AF' }}>
            {isCustomDesign ? 'Note!' : 'File Imported Successfully'}
          </span>
        </div>
        <button 
          onClick={onClose} 
          style={{ 
            background: 'none', 
            border: 'none', 
            cursor: 'pointer',
            padding: '4px'
          }}
        >
          {/* EF6950 red color */}
          <X size={window.innerWidth < 768 ? 14 : 16} color={isCustomDesign ? '#40C5AF' : '#40C5AF'} />
        </button>
      </div>
      <div style={{ 
        padding: window.innerWidth < 768 ? '0 4px' : '0 8px',
        width: '100%',
        color: isCustomDesign ? '#40C5AF' : '#40C5AF'
      }}>
        {isCustomDesign ? 'Import file to create column in database successfully completed' : message}
      </div>
    </div>
  );
};

// Configure AWS Lambda
AWS.config.update({
  region: awsExports.S3.region,
});

// Lambda invoker utility
const invokeLambda = async (action, payload, lambda, lambdaFunctionName) => {
  const params = {
    FunctionName: lambdaFunctionName,
    InvocationType: 'RequestResponse',
    Payload: JSON.stringify({ action, payload }),
  };

  try {
    const response = await lambda.invoke(params).promise();
    // console.log('response is: '+JSON.stringify(response));
    const result = JSON.parse(response.Payload);
    if (!result.success) throw new Error(result.error);
    return result.data;
  } catch (error) {
    console.error(`Error invoking Lambda (${action}):`, error);
    throw error;
  }
};

const ImportPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isETLLoading, setIsETLLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [showCsvEditor, setShowCsvEditor] = useState(false);
  const [notification, setNotification] = useState("");
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);
  const [csvFile, setCsvFile] = useState(null);
  const fileInputRef = useRef(null);
  const [importNotification,setImportNotifications] = useRecoilState(importNotificationsState);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadTitle, setUploadTitle] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [emailOptions, setEmailOptions] = useState({
    resubscribe: false,
    unsubscribe: false
  });
  const [mobileOptions, setMobileOptions] = useState({
    subscribeNew: false,
    unsubscribe: false
  });
  const [overwriteData, setOverwriteData] = useState(false);
  const [confirmOptIn, setConfirmOptIn] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const location = useLocation();
  const { configureLambda, decodeToken, getJWT } = useLambda();
  const [isOpen, setIsOpen] = useState(true);
  const cancelImportRef = useRef(false);
  const [successMessage, setSuccessMessage] = useState("");

  const roles = useRecoilValue(rolesState);
  const tenantGroup = useRecoilValue(tenantGroupState);
  const isSuperAdmin = useRecoilValue(isSuperAdminState);
  const isTenantAdminRole = useRecoilValue(isTenantAdminRoleState);
  const [isHovered, setIsHovered] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCustomDesign, setIsCustomDesign] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewFileData, setPreviewFileData] = useState([]);
  const [error, setError] = useState(null);
  const [responseError, setResponseError] = useRecoilState(responseErrorState);
  const [numeroActive, setNumeroActive] = useRecoilState(numeroActiveState);
  const [conversationId, setConversationId] = useRecoilState(conversationIdState);

  const [etlProgress, seteltProgress] = useState(10); // Start at 10%
  const [etltimeRemaining, setetlTimeRemaining] = useState(4);
  const [isFetching, setIsFetching] = useState(false);
  const [isETLComplete, setIsETLComplete] = useState(false);
  const [selectedTeam, setSelectedTeam] = useRecoilState(selectedTeamState);

  const updateNotifications = (success, header, message, timestamp) => {
    setImportNotifications((prevNotifications) => {
      const newNotification = {
        id: prevNotifications.length + 1,
        success,
        title: header,
        description: message,
        timestamp
      };
      const updatedNotifications = [...prevNotifications, newNotification];
      
      // Store in local storage
      localStorage.setItem('importNotifications', JSON.stringify(updatedNotifications));
      
      return updatedNotifications;
    });
  };

  

  const requiredHeaders = [
    'First Name', 'Last Name', 'Personal Email', 'Home City', 'Type of Contact', 'Middle Name', 'Home Street Address','Home State/Province', 
    'Home Zip/Postal', 'Country', 'Employer', 'Occupation', 'Job Title', 'Home Phone',
    'Date Received',  'Designation', 'Period', 'State House District',
    'State Senate District', 'Amount'
    // , 'Contact Type (Remedy PAC)'
  ];

  const requiredHeaders2 = [
    'First Name', 'Last Name', 'Home Street Address', 'Home Zip/Postal', 'Home City', 'Middle Name', 
    'Home State/Province', 
    'Employer', 'Occupation', 'Committee ID',  'Contact Name',
    'Date Received', 'Type of Contact', 'Designation', 'Period', 
     'Amount', 'Cycle', 'Home Street Address 2'
    // , 'Personal Email', 'Country', 'Job Title', 'Home Phone', 'State House District', 'State Senate District'
  ];


 
  const sanitizeFilename = (filename) => {
    return filename.replace(/\s+/g, '_').toLowerCase();
  };

  const convertToCSV = (data) => {
    const ws = XLSX.utils.aoa_to_sheet(data);
    return XLSX.utils.sheet_to_csv(ws);
  };


  const getFormattedDateTimeUTC = () => {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  };

  

  const handleImport = () => {
    fileInputRef.current.click();
  };

  const handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = '/import2.csv';
    link.download = 'import2.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showNotification('Template downloaded successfully');
  };

  const resetImportState = () => {
    setSelectedFile(null);
    setUploadTitle("");
    setCsvFile(null);
    setHeaders([]);
    setData([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleCancelImport = () => {
    setShowCsvEditor(false);
    resetImportState();
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => {
      setNotification("");
    }, 5000);
  };

  const validateHeaders = (headers) => {
    const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
    const extraHeaders = headers.filter(header => !requiredHeaders.includes(header));
    return { missingHeaders, extraHeaders };
  };

  const validateHeaders2 = (headers) => {
    const missingHeaders2 = requiredHeaders2.filter(header => !headers.includes(header));
    const extraHeaders2 = headers.filter(header => !requiredHeaders2.includes(header));
    return { missingHeaders2, extraHeaders2 };
  };

 
  const CHUNK_SIZE = 2 * 1024 * 1024; // Increased to 2MB chunks
  const MAX_FILE_SIZE = 500 * 1024 * 1024; // Increased to 500MB max file size

  const processLargeFile = async (file) => {
  return new Promise((resolve, reject) => {
    try {
      if (file.size > MAX_FILE_SIZE) {
        reject(new Error(`File size exceeds maximum limit of ${MAX_FILE_SIZE / (1024 * 1024)}MB`));
        return;
      }

      const reader = new FileReader();
      let offset = 0;
      let buffer = new ArrayBuffer(0);

      reader.onload = async (e) => {
        try {
          const newBuffer = new ArrayBuffer(buffer.byteLength + e.target.result.byteLength);
          const newBufferView = new Uint8Array(newBuffer);
          newBufferView.set(new Uint8Array(buffer), 0);
          newBufferView.set(new Uint8Array(e.target.result), buffer.byteLength);
          buffer = newBuffer;

          offset += e.target.result.byteLength;
          setUploadProgress(Math.min((offset / file.size) * 100, 100));

          if (offset < file.size) {
            readNextChunk();
          } else {
            const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            resolve(processDataWithUniqueHeaders(jsonData));
          }
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => reject(error);

      const readNextChunk = () => {
        const slice = file.slice(offset, offset + CHUNK_SIZE);
        reader.readAsArrayBuffer(slice);
      };

      readNextChunk();
    } catch (error) {
      reject(error);
    }
  });
};

  const fetchFilesFromS3 = async (selectedTeam) => {
    try {
      const token = await getJWT();
      await configureLambda(token);
      // console.log('tenant group is: '+tenantGroup);
      const s3 = new AWS.S3({
        region: awsExports.S3.region,
      });
      
      const tenantGroup = selectedTeam.name;
      const folderPath = `Tenants/${tenantGroup}/ClientCreate/`;
      const params = {
        Bucket: awsExports.S3.bucket,
        Prefix: folderPath,
      };
  
      const data = await s3.listObjectsV2(params).promise();
      // Filter out the folder itself (e.g., TENANTS/PUBLIC/CLIEMYMBASE/)
      const files = data.Contents
        .filter((file) => !file.Key.endsWith('/')) // Exclude folders
        .map((file) => {
          const fileName = file.Key.replace(folderPath, ''); // Remove folder path
          const fileType = fileName.split('.').pop().toUpperCase(); // Extract file type
          const baseName = fileName.replace(/\.[^/.]+$/, "").replace(/_/g, ' ');   // Extract base name (e.g., testing2)
  
          // Remove the last part (date-time format) from the base name
          const displayName = baseName.replace(/\s+\d{8}T\d{6}Z$/, '');

          return {
            name: fileName,
            baseName, // Store the base name (e.g., Lateefah Simon Team Test 20250316T232508Z)
            displayName, // Store the display name (e.g., Lateefah Simon Team Test)
            type: fileType,
            dateUploaded: new Date(file.LastModified).toLocaleDateString(),
            lastModified: file.LastModified, // Keep the LastModified date for sorting
            progress: 100,
            total: `${(file.Size / (1024 * 1024)).toFixed(2)} MB`, // Display size in MB
            email: '-',
            mobile: '-',
          };
        });
  
      // Sort files by LastModified date in descending order
      files.sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified));
  
      // Track the count of files with the same base name
      const nameCount = new Map();
  
      // Rename files with duplicate base names
      files.forEach((file) => {
        if (nameCount.has(file.displayName)) {
          const count = nameCount.get(file.displayName);
          file.displayName = `${file.displayName} (${count})`; // Rename existing file
          nameCount.set(file.displayName, count + 1); // Increment the count
        } else {
          nameCount.set(file.displayName, 1); // Initialize the count
          file.displayName = file.displayName; // No renaming needed for the first file
        }
      });
  
      return files;
    } catch (error) {
      console.error('Error fetching files from S3:', error);
      return [];
    }
  };

  useEffect(() => {
    const fetchFiles = async () => {
      const files = await fetchFilesFromS3(selectedTeam);
      setUploadedFiles(files);
    };
  
    fetchFiles();
  }, [selectedTeam]); // Fetch files whenever the tenantGroup changes

  const processDataWithUniqueHeaders = (jsonData) => {
  if (!jsonData || jsonData.length === 0) return { headers: [], data: [] };
  
  const headers = jsonData[0] || [];
  const headerMap = new Map();
  
  // Track each column's data and count non-empty cells
  headers.forEach((header, colIndex) => {
    const normalizedHeader = String(header || `empty_${colIndex}`).trim().toLowerCase();
    
    if (!headerMap.has(normalizedHeader)) {
      headerMap.set(normalizedHeader, []);
    }
    
    let dataCount = 0;
    for (let rowIndex = 1; rowIndex < jsonData.length; rowIndex++) {
      const cellValue = jsonData[rowIndex]?.[colIndex];
      if (cellValue !== undefined && cellValue !== null && cellValue !== '') {
        dataCount++;
      }
    }
    
    headerMap.get(normalizedHeader).push({
      originalHeader: header,
      colIndex,
      dataCount
    });
  });
  
  // Determine which columns to keep
  const columnsToKeep = [];
  const uniqueHeaders = [];
  
  headerMap.forEach((columns) => {
    // Keep column with most data, or first if equal
    const bestColumn = columns.reduce((prev, current) => 
      (current.dataCount > prev.dataCount) ? current : prev
    );
    columnsToKeep.push(bestColumn.colIndex);
    uniqueHeaders.push(bestColumn.originalHeader);
  });
  
  // Maintain original column order
  columnsToKeep.sort((a, b) => a - b);
  
  // Filter the data
  const filteredData = jsonData.slice(1).map(row => 
    columnsToKeep.map(colIndex => row[colIndex])
  );
  
  return { headers: uniqueHeaders, data: filteredData };
};

const handleFileUpload = async (file) => {
  if (!file) return;
  
  const allowedExtensions = /(\.csv|\.xls|\.xlsx|\.xml|\.gsheet)$/i;
  if (!allowedExtensions.exec(file.name)) {
    alert('Please select a CSV, Excel, XML, or Google Sheets file.');
    resetImportState();
    return;
  }

  setIsLoading(true);

  try {
    let result;
    if (file.size > 10 * 1024 * 1024) {
      result = await processLargeFile(file);
    } else {
      const arrayBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      result = processDataWithUniqueHeaders(jsonData);
    }
  
    const { headers: importedHeaders, data } = result;
    const { missingHeaders, extraHeaders } = validateHeaders(importedHeaders);
  
    setHeaders(importedHeaders);
    setData(data);

    const csvContent = new Blob(
      [[importedHeaders.join(',')]].concat(
        data.map(row => row.map(cell => 
          typeof cell === 'string' ? `"${cell.replace(/"/g, '""')}"` : cell
        ).join(','))
      ),
      { type: 'text/csv' }
    );
  
    setCsvFile(new File([csvContent], file.name.replace(/\.[^/.]+$/, ".csv"), { type: 'text/csv' }));
    setShowCsvEditor(true);
    showNotification('File imported successfully');
      
    if (missingHeaders.length > 0 || extraHeaders.length > 0) {
      let message = "Please review the headers:\n";
      if (missingHeaders.length > 0) message += `Missing: ${missingHeaders.join(', ')}\n`;
      if (extraHeaders.length > 0) message += `Extra: ${extraHeaders.join(', ')}`;
      alert(message);
    }
  } catch (error) {
    console.error('Error processing file:', error);
    alert(`Error processing file: ${error.message || 'Please try again.'}`);
    resetImportState();
  } finally {
    setIsLoading(false);
  }
};


  const handleDirectImport = (fileName, headers, data) => {
    // Implement your direct import logic here
    //console.log("Directly importing file:", fileName);
    //console.log("Headers:", headers);
    //console.log("Data:", data);

    // Simulating a successful import
    const importSuccessful = true;  // Replace this with your actual import logic

    if (importSuccessful) {
      updateNotifications(true,'Import Notification', `File "${fileName}" imported successfully`, new Date().getTime());
      alert(`Import successful! File "${fileName}" has been imported.`);
      // setUploadedFiles(prevFiles => [...prevFiles, {
      //   name: fileName,
      //   dateUploaded: new Date().toLocaleDateString(),
      //   progress: 100,
      //   total: `${(data.length * 0.0001).toFixed(2)} MB`, // Estimating file size
      //   email: '-',
      //   mobile: '-'
      // }]);
    } else {
      updateNotifications(false,'Import Notification', `Import failed for file "${fileName}". Please check your file and try again.`, new Date().getTime());
      alert(`Import failed for file "${fileName}". Please try again.`);
    }

    resetImportState();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    setFileSelected(true);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFileSelection(files[0]);
    }
  };

  const handleHeaderChange = (index, newHeader) => {
    const updatedHeaders = [...headers];
    updatedHeaders[index] = newHeader;
    setHeaders(updatedHeaders);
  };

  const handleAddColumn = () => {
    setHeaders([...headers, '']);
  };

  const handleDeleteColumn = (index) => {
    const updatedHeaders = headers.filter((_, i) => i !== index);
    const updatedData = data.map(row => row.filter((_, i) => i !== index));
    setHeaders(updatedHeaders);
    setData(updatedData);
  };
      
  const fetchFileData = async (fileName) => {
  try {
    const lambda = new AWS.Lambda();
    const jwtToken = await getJWT();
    const payload = {
      action: 'getClientCreateStg',
      payload: {
        jwtToken: jwtToken,
        schema: selectedTeam.name,
        filename: fileName,
      },
    };
  
    const response = await lambda.invoke({
      FunctionName: awsExports.Lambda.queryManagement,
      InvocationType: 'RequestResponse',
      Payload: JSON.stringify(payload),
    }).promise();

    const result = JSON.parse(response.Payload);
    if (result.success) {
      setPreviewFileData(processDataWithUniqueHeaders(result.data));
      setIsPreviewModalOpen(true);
    } else {
      console.error('Error fetching data:', result.error);
      alert(`Error: ${result.error}`);
    }
  } catch (error) {
    console.error('Lambda error:', error);
    alert('Failed to fetch file data');
  }
};


  // Function to handle search icon click
  const handleSearchClick = (file) => {
    const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
    // console.log('file name is: ' + fileNameWithoutExtension);
    fetchFileData(fileNameWithoutExtension); // Fetch file data
  };



  const FileUploadInfo = ({ uploadedFiles, onSearchClick }) => {
    const navigate = useNavigate();
    const [showAllFiles, setShowAllFiles] = useState(false); // State to control visibility
  
    // Determine the number of files to display
    const visibleFiles = showAllFiles ? uploadedFiles : uploadedFiles.slice(0, 5);
  
    const handleDeleteFromDB = async (file) => {
      try {
        const lambda = new AWS.Lambda();
        const jwtToken = await getJWT();
        const requested_items = ['cognito:groups'];
        const payload = {
          action: 'deleteClientCreateStg',
          payload: {
            jwtToken: jwtToken,
            requested_items: requested_items,
            schema: selectedTeam.name, // Replace with your schema name
            filename: file.name,
          },
        };
  
        const response = await lambda.invoke({
          FunctionName: awsExports.Lambda.queryManagement, // Replace with your Lambda function name
          InvocationType: 'RequestResponse',
          Payload: JSON.stringify(payload),
        }).promise();
        // console.log('response inside the fetchFilesData: ' + JSON.stringify(response));
  
        const result = JSON.parse(response.Payload);
        if (result.success) {
          setPreviewFileData(result.data); // Set the fetched data
          setIsPreviewModalOpen(true); // Open the preview modal
        } else {
          console.error('Error fetching file data:', result.error);
          alert(`Failed to fetch file data: ${result.error}`);
        }
      } catch (error) {
        console.error('Error invoking Lambda:', error);
        alert('An error occurred while fetching file data. Please try again.');
      }
    };
  
    const handleRemoveClick = async (file) => {
      //console.log('file name is: ' + file.name);
  
      try {
        const token = await getJWT();
        configureLambda(token);
        const s3 = new AWS.S3({
          region: awsExports.S3.region,
        });
        const tenantGroup = selectedTeam.name;
        const params = {
          Bucket: awsExports.S3.bucket,
          Key: `Tenants/${tenantGroup}/ClientCreate/${file.name}`, // Construct the full path to the file
        };
  
        await s3.deleteObject(params).promise();
        handleDeleteFromDB(file);
        //console.log(`File ${file.name} deleted successfully`);
  
        // Optionally, update the state to remove the deleted file from the list
        setUploadedFiles((prevFiles) => prevFiles.filter((f) => f.name !== file.name));
      } catch (error) {
        console.error('Error deleting file from S3:', error);
        alert('An error occurred while deleting the file. Please try again.');
      }
    };
  
    return (
      <>
        <div className="flex items-center gap-5 self-stretch py-2.5 px-5 border-b border-[#D9D9D9] bg-white">
          <p className="w-[20rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">File Name</p>
          <p className="w-[8rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">File Type</p>
          <p className="w-[10rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">Date Uploaded</p>
          <p className="w-[6rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">Progress</p>
          <p className="w-[6rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">Total</p>
          <p className="w-[6rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">Search</p>
          <p className="w-[6rem] text-[#8E8E8E] font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">Delete</p>
        </div>
  
        {/* Display visible files */}
        {visibleFiles.map((file, index) => (
          <div className="flex flex-col items-start self-stretch" key={index}>
            <div className="flex flex-col items-start gap-2.5 self-stretch p-2.5 border-b border-[#D9D9D9] bg-white">
              <div className="flex justify-between items-center self-stretch p-2.5">
                {/* File Name */}
                <p
                  className="w-[20rem] text-black text-base font-normal leading-[120%] break-words"
                  style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
                >
                  {file.displayName} {/* Display the formatted file name */}
                </p>
  
                {/* File Type */}
                <p className="w-[8rem] text-black text-base font-normal leading-[120%]">
                  {file.type}
                </p>
  
                {/* Date Uploaded */}
                <p className="w-[10rem] text-black text-base font-normal leading-[120%]">
                  {file.dateUploaded}
                </p>
  
                {/* Progress */}
                <p className="w-[6rem] text-black text-base font-normal leading-[120%]">
                  {file.progress}%
                </p>
  
                {/* Total */}
                <p className="w-[6rem] text-black text-base font-normal leading-[120%]">
                  {file.total}
                </p>
  
                {/* Search Button */}
                <div className="w-[6rem] flex justify-center">
                  <button
                    onClick={() => onSearchClick(file)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    <img
                      src="/searchfile.png"
                      alt="Search"
                      style={{ width: '24px', height: '24px' }}
                    />
                  </button>
                </div>
  
                {/* Delete Button */}
                <div className="w-[6rem] flex justify-center">
                  <button
                    className="text-[#EF6950] font-inter text-[13px] font-bold leading-[120%] hover:text-[#EF6950]/80 transition-colors duration-200 whitespace-nowrap"
                    onClick={() => handleRemoveClick(file)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
  
        {/* "View More" Button */}
        {uploadedFiles.length > 5 && (
          <div className="flex justify-center items-center mt-4">
            <button
              onClick={() => setShowAllFiles(!showAllFiles)}
              className="flex items-center gap-2 text-[#40C5AF] font-['Inter'] text-base font-normal leading-[120%] hover:text-[#30A58E] transition-colors"
            >
              {showAllFiles ? (
                <>
                  <ChevronUp size={16} color="#40C5AF" />
                  <span>View Less</span>
                </>
              ) : (
                <>
                  <ChevronDown size={16} color="#40C5AF" />
                  <span>View More</span>
                </>
              )}
            </button>
          </div>
        )}
      </>
    );
  };

  const themeStyles = {
    backgroundColor: '#FFF',
    color: '#000',
    minHeight: '100vh',
    display: "flex",
    width: "100%"
  };

  useEffect(() => {
    // Check localStorage when component mounts
    const storedFileSelected = localStorage.getItem('fileSelected') === 'true';
    setFileSelected(storedFileSelected);

    // Cleanup function to clear localStorage when component unmounts
    return () => {
      localStorage.removeItem('fileSelected');
    };
  }, []);

  const handleFileSelection = (file) => {
    if (file) {
      setSelectedFile(file);
      setFileSelected(true);
      localStorage.setItem('fileSelected', 'true');
    }
  };

  const [isUploading, setIsUploading] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(4);

  // const handleUploadButtonClick = () => {
  //   setIsUploading(true);
  //   setUploadProgress(0);
  //   setTimeRemaining(4);
  // };

 const handleUploadButtonClick = async () => {
  if (!selectedFile) {
    alert("Please select a file first.");
    return;
  }

  setIsUploading(true);
  setUploadProgress(0);
  setTimeRemaining(4);

  try {
    let result;
    if (selectedFile.size > 10 * 1024 * 1024) {
      result = await processLargeFile(selectedFile);
    } else {
      const arrayBuffer = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      result = processDataWithUniqueHeaders(jsonData);
    }
  
    const fileType = selectedFile.name.split('.').pop().toUpperCase();
    const files = await fetchFilesFromS3(selectedTeam);
  
    navigate('/match-fields', {
      state: {
        headers: result.headers,
        data: result.data,
        requiredHeaders,
        uploadTitle,
        fileName: selectedFile.name,
        selectedTeam,
        uploadType: fileType,
        uploadedFiles: files,
      },
    });
  } catch (error) {
    console.error('Upload error:', error);
    alert(`Error processing file: ${error.message || 'Please try again.'}`);
  } finally {
    setIsUploading(false);
  }
};

  useEffect(() => {
    let intervalId;
    if (isUploading && uploadProgress < 100) {
      intervalId = setInterval(() => {
        setUploadProgress(prev => {
          const newProgress = prev + 5;
          if (newProgress >= 100) {
            setIsUploading(false);
            clearInterval(intervalId);
            return 100;
          }
          return newProgress;
        });
        setTimeRemaining(prev => Math.max(0, prev - 0.2));
      }, 200);
    }
    return () => clearInterval(intervalId);
  }, [isUploading, uploadProgress]);

  const handleUploadButtonClick2 = async () => {
  if (!selectedFile) {
    alert("Please select a file first.");
    return;
  }

  setIsUploading(true);
  setUploadProgress(0);
  setTimeRemaining(4);

  try {
    let result;
    if (selectedFile.size > 10 * 1024 * 1024) {
      result = await processLargeFile(selectedFile);
    } else {
      const arrayBuffer = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      result = processDataWithUniqueHeaders(jsonData);
    }
  
    const fileType = selectedFile.name.split('.').pop().toUpperCase();
    const files = await fetchFilesFromS3(selectedTeam);
  
    navigate('/match-fields2', {
      state: {
        headers: result.headers,
        data: result.data,
        requiredHeaders2,
        uploadTitle,
        fileName: selectedFile.name,
        selectedTeam,
        uploadType: fileType,
        uploadedFiles: files,
      },
    });
  } catch (error) {
    console.error('Upload error:', error);
    alert(`Error processing file: ${error.message || 'Please try again.'}`);
  } finally {
    setIsUploading(false);
  }
};

  useEffect(() => {
    let intervalId;
    if (isUploading && uploadProgress < 100) {
      intervalId = setInterval(() => {
        setUploadProgress(prev => {
          const newProgress = prev + 5;
          if (newProgress >= 100) {
            setIsUploading(false);
            clearInterval(intervalId);
            return 100;
          }
          return newProgress;
        });
        setTimeRemaining(prev => Math.max(0, prev - 0.2));
      }, 200);
    }
    return () => clearInterval(intervalId);
  }, [isUploading, uploadProgress]);

  const handlePDFDownload = (pdfPath) => {
    // Create a link element
    const link = document.createElement('a');
    link.href = pdfPath;
    link.target = '_blank';
    link.download = pdfPath.split('/').pop(); // Set the download attribute to the file name

    // Append to the document body
    document.body.appendChild(link);

    // Trigger the click event
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  };

  // useEffect(() => {
  //   if (location.state?.success) {
  //     // Set the success message directly, ensuring it's formatted correctly
  //     setSuccessMessage(location.state.message); // This should include <br /> or be formatted as an array
  //     if (location.state.uploadedFile) {
  //       setUploadedFiles(prevFiles => {
  //         const newFile = location.state.uploadedFile;
  //         const fileExists = prevFiles.some(file => 
  //           file.name === newFile.name && file.dateUploaded === newFile.dateUploaded
  //         );
  //         if (!fileExists) {
  //           return [...prevFiles, newFile];
  //         }
  //         return prevFiles;
  //       });
  //     }
  //     // Clear the success state from the location object
  //     navigate(location.pathname, { replace: true, state: {} });
  //   }
  // }, [location, navigate]);
  
  
  useEffect(() => {
    if (successMessage) {
      setShowSuccessMessage(true);
      const timer = setTimeout(() => {
        setShowSuccessMessage(false);
        setSuccessMessage('');
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleCloseSuccessMessage = () => {
    setShowSuccessMessage(false);
    setSuccessMessage('');
  };

  const handleFileInputChange = (e) => {
    // Handle file selection logic here
    setFileSelected(e.target.files.length > 0);
  };

  const clearFileSelection = () => {
    setSelectedFile(null);
    setFileSelected(false);
    localStorage.removeItem('fileSelected');
  };

  const lambda = new AWS.Lambda();

  useEffect(() => {
    if (!isFetching) {
      // Fake progress before actual fetch starts
      const fakeProgress = setInterval(() => {
        seteltProgress((prev) => (prev < 40 ? prev + 5 : prev)); // Stop at 40%
      }, 1000);

      return () => clearInterval(fakeProgress); // Cleanup when fetching starts
    }
  }, [isFetching]);

  const fetchETLStatus = async (fileName) => {
    setIsFetching(true);
    const payload = {
      operation: 'stepFunctionStatus',
    };
  
    const invokeLambda = async () => {
      try {
        const response = await lambda
          .invoke({
            FunctionName: awsExports.Lambda.userManagement, // Replace with your Lambda function name
            InvocationType: 'RequestResponse',
            Payload: JSON.stringify(payload),
          })
          .promise();
  
       // console.log('Response inside fetchETLStatus:', JSON.stringify(response));
  
        const result = JSON.parse(response.Payload);
        const body = JSON.parse(result.body); // Parse the nested body

        if (body.status === 'SUCCEEDED') {
          clearInterval(pollingInterval); // Stop polling
          setIsETLLoading(false);
          seteltProgress(100);
          setSuccessMessage('ETL process completed successfully!');
        } else if (body.status === 'FAILED') {
          clearInterval(pollingInterval); // Stop polling
          setIsFetching(false);
          setIsETLLoading(false);
          console.error('Lambda function execution failed:', body.error);
          alert(`Lambda function execution failed: ${body.error}`);
        } else {
          // Update progress based on the ETL process status
        }
      } catch (error) {
        clearInterval(pollingInterval); // Stop polling
        console.error('Error invoking Lambda:', error);
        alert('An error occurred while fetching file data. Please try again.');
      }
    };

    // Slow progress towards 90% while waiting for SUCCEEDED or FAILED
    const smoothProgress = setInterval(() => {
      seteltProgress((prev) => (prev < 90 ? prev + 2 : prev));
    }, 2000);
  
    // Start polling every 5 seconds
    const pollingInterval = setInterval(invokeLambda, 5000);
  
    // Optionally, invoke immediately before starting the interval
    await invokeLambda();
    return () => {
      clearInterval(smoothProgress);
    };
  };
  useEffect(() => {
    if (isETLLoading) {
      // Set a timeout to delay the fetchETLStatus call by 30 seconds
      const timeoutId = setTimeout(() => {
        fetchETLStatus();
      }, 8000); // 30 seconds delay
  
      // Cleanup function to clear the timeout if the component unmounts or isETLLoading changes
      return () => clearTimeout(timeoutId);
    }
  }, [isETLLoading]);

  useEffect(() => {
    if (location.state?.success) {
      // Set the success message and custom design flag
      setSuccessMessage(location.state.message);
      setIsCustomDesign(location.state.isCustomDesign || false);
      setIsETLLoading(location.state.isETLLoading || false);

      // Only add the file to uploadedFiles if it was NOT uploaded via "Upload into database"
      if (location.state.uploadedFile && !location.state.isUploadIntoDatabase) {
        setUploadedFiles(prevFiles => {
          const newFile = location.state.uploadedFile;
          const fileExists = prevFiles.some(file => 
            file.name === newFile.name && file.dateUploaded === newFile.dateUploaded
          );
          if (!fileExists) {
            return [...prevFiles, newFile];
          }
          return prevFiles;
        });
      }

      // Clear the success state from the location object
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  // console.log('isETLLoading: '+isETLLoading);
  return (
    <div className="h-screen bg-white overflow-hidden">
      <div className="h-full flex">
        {/* Main content */}
        <div className="flex-1 flex flex-col w-full">   
          <div className="flex-1 w-full">
            <div className="w-full">
              <WelcomeHeader />
            </div>
            
            <main className="h-[calc(100vh-theme(spacing.16))] p-10 flex flex-col gap-10 overflow-y-auto">
              <div className="flex justify-between items-center">
                <div className="flex flex-col items-start gap-1.5">
                  <h2 className="text-xl md:text-2xl font-inter font-bold">Import File</h2>
                  <p className="text-sm md:text-base">Please upload a file below to match columns in your database.</p>
                </div>
              </div>
            
              <section className="flex flex-col items-start gap-5">
                  <div className="flex flex-col items-start gap-5 w-[50rem] py-5 border-t border-[#D9D9D9] bg-white">
                    {/* File Upload heading */}
                    <div className="flex flex-col items-start gap-5 w-[50rem]">
                      <div className="flex flex-col items-start gap-2.5 self-stretch">
                        <p className="self-stretch text-black font-inter text-base font-bold leading-tight">File Upload</p>
                        <p className="self-stretch font-['Inter'] text-[0.8125rem] font-normal leading-[120%]" style={{ color: 'var(--foundation-primary-black-light-active, #8E8E8E)' }}>
                          <span>
                            Upload a CSV, XLS, or XLSX file to add to the donor database, with the first row indicating your column names. You will be asked to match your columns to the relevant fields in the database.
                          </span>
                          <br />
                          <br />
                          <span>
                            Important Note: Only the columns that have been matched will be moved into Findraiser's database. Please make sure you create relevant mapping for any column that you want imported. Please contact your administrator if you cannot find relevant mapping for a column.
                          </span>
                        </p>
                      </div>    
                    </div>

                    {/*File Upload/Dragging box rounded-lg p-4 md:p-8 text-center cursor-pointer */}
                    <div className={`
                      flex flex-col justify-center items-center w-[50rem] p-6 gap-3 rounded-[0.4375rem]
                      border ${isDragging ? 'border-solid border-[rgba(242,202,100,255)]' : 'border-dashed border-[#EBAE12]'}
                      transition-all duration-300 
                      ${isDragging || isHovered || fileSelected ? 'bg-[#FDF7E7]' : 'bg-white'}
                    `}
                      onDragEnter={handleDragEnter}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onClick={() => fileInputRef.current.click()}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      <img 
                        src="/upload.png"
                        alt="Upload icon"
                        className="w-[2.625rem] h-[2.625rem]"
                      />
                      <div className="flex flex-col items-center gap-2 self-stretch">
                        <div className="flex justify-center items-start gap-1 self-stretch">
                          <p className="text-black font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">
                            Drag your file(s) to start uploading
                          </p>
                        </div>

                        <div className="flex items-center w-[12.5625rem] gap-3">
                          <div className="h-[0.06069rem] flex-1 flex-shrink-0 bg-[#8E8E8E]"></div>
                          <span className="text-center font-['Inter'] text-[0.8125rem] font-normal leading-[120%]"
                                style={{ color: 'var(--foundation-primary-black-light-active, #8E8E8E)' }}
                          > 
                            OR
                          </span>
                          <div className="h-[0.06069rem] flex-1 flex-shrink-0 bg-[#8E8E8E]"></div>
                        </div>

                        <button 
                          className="flex py-1.5 px-3 justify-center items-center gap-1 
                                    bg-white text-[#EBAE12] font-['Inter'] font-bold text-base leading-[120%] 
                                    rounded-[0.4375rem] border border-[#EBAE12] 
                                    hover:bg-[#EBAE12] hover:text-white transition duration-300 
                                    focus:outline-none focus:ring-2 focus:ring-yellow-300"
                          onClick={(e) => {
                            e.stopPropagation();
                            fileInputRef.current.click();
                          }}
                        >
                          Browse files
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleFileInputChange}
                          className="hidden"
                          multiple
                        />
                      </div>
                    </div>
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(e) => handleFileSelection(e.target.files[0])}
                      accept=".csv,.xls,.xlsx"
                    />

                    <p className="w-[50rem] h-5 overflow-hidden text-[#8E8E8E] truncate
                                font-['Inter'] text-[0.8125rem] font-normal leading-[120%]">
                          Supported file formats: .csv, .xls, .xlsx
                    </p>

                    {selectedFile && (
                      <div className="flex justify-between items-center self-stretch p-4 rounded-[0.4375rem] border border-[#D9D9D9] bg-white">
                        <div className="flex items-end gap-[1.0625rem]">
                          <img 
                            src="/file-icon.png"
                            alt="File icon"
                            className="w-[36px] h-[36px] mr-3 mt-1"
                          />
                          <div className="w-full">
                            {isUploading ? (
                              <>
                                <div className="flex items-center justify-between mb-1">
                                  <span className="text-sm font-inter font-bold">Uploading...</span>
                                </div>
                                <div className="text-gray-500 font-inter text-xs mb-2">
                                  {uploadProgress}% • {Math.ceil(timeRemaining)} seconds remaining
                                </div>
                                <div className="w-full bg-gray-200 rounded-full h-1.5">
                                  <div 
                                    className="bg-[rgba(99,207,190,255)] h-1.5 rounded-full" 
                                    style={{width: `${uploadProgress}%`}}
                                  ></div>
                                </div> 
                              </>
                            ) : (
                              <>
                                <p className="font-bold text-sm">{selectedFile.name}</p>
                                <p className="text-xs text-gray-500">{(selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>
                              </>
                            )}
                          </div>
                        </div>
                        <button 
                          onClick={() => {
                            setIsUploading(false);
                            setSelectedFile(null);
                          }} 
                          className="flex items-center justify-center h-5 w-5 text-gray-600 hover:text-gray-800 font-bold ml-2"
                        >
                          <X size={16} strokeWidth={2.5} />
                        </button>
                      </div>
                    )}
                    {isETLLoading && (
                      <div className="flex justify-between items-center self-stretch p-4 rounded-[0.4375rem] border border-[#D9D9D9] bg-white">
                        <div className="flex items-end gap-[1.0625rem]">
                          <img 
                            src="/file-icon.png"
                            alt="File icon"
                            className="w-[36px] h-[36px] mr-3 mt-1"
                          />
                          <div className="w-full">
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-sm font-inter font-bold">Processing...</span>
                            </div>
                            <div className="text-gray-500 font-inter text-xs mb-2">
                              {etlProgress}%
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-1.5">
                              <div 
                                className="bg-[rgba(99,207,190,255)] h-1.5 rounded-full" 
                                style={{width: `${etlProgress}%`}}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <button 
                          onClick={() => {
                            setIsETLLoading(false);
                          }} 
                          className="flex items-center justify-center h-5 w-5 text-gray-600 hover:text-gray-800 font-bold ml-2"
                        >
                          <X size={16} strokeWidth={2.5} />
                        </button>
                      </div>
                    )}

                      <div className="flex justify-end items-start gap-4 self-stretch">
                        <div className="flex items-start gap-4"> {/* Add gap-4 here for spacing between buttons */}
                          <button
                            className={`
                              font-bold flex justify-center items-center py-2.5 px-3.5 gap-1 rounded-[0.4375rem] transition duration-300 text-base leading-[120%]
                              ${selectedFile && !isUploading
                                ? 'bg-[#ebae12] text-white hover:bg-white hover:text-[#ebae12] border-2 border-[#ebae12]' 
                                : 'bg-[rgb(204,204,204)] text-[rgba(142,142,142,255)] cursor-not-allowed border border-[rgb(204,204,204)]'}
                            `}
                            onClick={handleUploadButtonClick2}
                            disabled={!selectedFile || isUploading}
                          >
                            <Upload className="mr-2" size={14} />
                            Compare Uploaded Donors
                          </button>

                          <button
                            className={`
                              font-bold flex justify-center items-center py-2.5 px-3.5 gap-1 rounded-[0.4375rem] transition duration-300 text-base leading-[120%]
                              ${selectedFile && !isUploading
                                ? 'bg-[#ebae12] text-white hover:bg-white hover:text-[#ebae12] border-2 border-[#ebae12]' 
                                : 'bg-[rgb(204,204,204)] text-[rgba(142,142,142,255)] cursor-not-allowed border border-[rgb(204,204,204)]'}
                            `}
                            onClick={handleUploadButtonClick}
                            disabled={!selectedFile || isUploading}
                          >
                            <Upload className="mr-2" size={14} />
                            Upload Donors File
                          </button>
                        </div>
                      </div>

                    {uploadedFiles.length > 0 && (
                      <div className="flex flex-col w-[50rem] py-5 items-start gap-5 border-t border-[#D9D9D9]">
                        <div className="flex flex-col items-start gap-2.5 self-stretch">
                          <p className="text-black font-['Inter'] text-base font-bold leading-[120%] self-stretch">
                            Uploaded Files
                          </p>
                        </div>
                        <div className="flex flex-col items-start w-[50rem]">
                          <FileUploadInfo 
                            uploadedFiles={uploadedFiles} 
                            onSearchClick={handleSearchClick} // Pass the onSearchClick prop
                          />
                          {/* Render the FilePreviewModal */}
                          <FilePreviewModal
                            isOpen={isPreviewModalOpen}
                            onClose={() => setIsPreviewModalOpen(false)}
                            fileData={previewFileData}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                {isLoading && (
                  <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                    <ClipLoader color="#ffffff" size={50} />
                  </div>
                )}
              </section> 
          </main>
        </div>
      </div>
    </div>
    {showSuccessMessage && (
        <SuccessMessage 
          message={successMessage} 
          onClose={handleCloseSuccessMessage}
          isCustomDesign={isCustomDesign} // Pass custom design flag
        />
      )}
  </div>
);
};

export default ImportPage;